import styled from 'styled-components'

export const Main = styled.div`
font-size: .875rem;
h2,h4{
    color: var(--a4);
}
`

export const SubtitleDiv = styled.div`
margin-bottom: .5rem;
display: flex;
flex-direction: column;
span{
    font-weight: bold;
    font-size: .813rem;
}
`

export const LabelTitle = styled.label`
    color: var(--a4);
    font-weight: 500;
    margin-bottom: 0.25rem;
    font-size:1.5rem;
    line-height: 1.75rem;
    font-weight: bold;
`
